import React, { useState, forwardRef, useImperativeHandle } from 'react'
import './Login.css'
import toast from 'react-hot-toast'
import axios from 'axios'
import { Link } from 'react-router-dom'

const Login = forwardRef((props, ref) => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const login = async () => {
        const url = `${process.env.REACT_APP_API_URL}/login`;
        
        try {
            const response = await axios.post(url, {
                email: email,
                password: password
            })
            
            if (response.data.success) {
                toast.success("ورود موفقیت‌آمیز")
                localStorage.setItem('currentUser', JSON.stringify(response.data.data))
                
                // ========== بستن مودال ==========
                closeModal();
                
                if (props.onSuccess) {
                    props.onSuccess()
                } else {
                    toast.loading("در حال انتقال به صفحه اصلی")
                    setTimeout(() => {
                        toast.dismiss()
                        window.location.href = '/'
                    }, 2000)
                }
            } else {
                toast.error(response.data.message || "اطلاعات وارد شده صحیح نیست")
            }
        } catch (err) {
            console.error("Login error:", err);
            toast.error("خطا در ورود. لطفاً دوباره تلاش کنید")
        }
    }

    // ========== تابع بستن مودال ==========
    const closeModal = () => {
        const modalElement = document.getElementById('exampleModal');
        if (modalElement) {
            modalElement.classList.remove('show');
            modalElement.style.display = 'none';
            document.body.classList.remove('modal-open');
            
            // حذف backdrop
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) backdrop.remove();
            
            // حذف کلاس‌های اضافی
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }
    }

    // ========== تابع باز کردن مودال ==========
    const openModal = () => {
        const modalElement = document.getElementById('exampleModal');
        if (modalElement) {
            modalElement.classList.add('show');
            modalElement.style.display = 'block';
            document.body.classList.add('modal-open');
            document.body.style.overflow = 'hidden';
            
            // اضافه کردن backdrop اگر وجود ندارد
            if (!document.querySelector('.modal-backdrop')) {
                const backdrop = document.createElement('div');
                backdrop.className = 'modal-backdrop fade show';
                document.body.appendChild(backdrop);
            }
        }
    }

    // متد برای باز کردن مودال از بیرون
    useImperativeHandle(ref, () => ({
        openModal: openModal,
        closeModal: closeModal
    }));

    return (
        <div>
            <div className="modal fade text-dark" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">ورود به حساب کاربری</h1>
                            {/* ========== دکمه ضربدر ========== */}
                            <button 
                                type="button" 
                                className="btn-close" 
                                aria-label="Close"
                                onClick={closeModal}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className='form-group mb-3 p-2'>
                                <label htmlFor="email">آدرس ایمیل</label>
                                <input 
                                    type="email" 
                                    className="form-control" 
                                    id="email" 
                                    aria-describedby="emailHelp" 
                                    placeholder="ایمیل خود را وارد کنید" 
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)} 
                                />
                            </div>
                            <div className='form-group p-2'>
                                <label htmlFor="password">رمز عبور</label>
                                <input 
                                    type="password" 
                                    className="form-control" 
                                    id="password" 
                                    placeholder="رمز عبور خود را وارد کنید" 
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)} 
                                />
                            </div>
                        </div>
                        <button 
                            type="button" 
                            className="btn btn-warning w-100" 
                            onClick={login}
                        >
                            ورود
                        </button>
                        <div className="text-center mt-2">
                            <Link to="/forget-password" className="small text-muted">رمز عبور خود را فراموش کرده‌اید؟</Link>
                        </div>
                        <div className="modal-footer">
                            <p className='my-0 mx-auto'>حساب کاربری ندارید؟ <a href="/signup">ثبت‌نام کنید</a></p>
                            {/* ========== دکمه انصراف ========== */}
                            <button 
                                type="button" 
                                className="btn btn-danger" 
                                onClick={closeModal}
                            >
                                انصراف
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default Login